
import { NormalizedFormat } from '@/types/apptypes';
import Vue from 'vue';
import Spinner from '@/components/Spinner.vue';
export default Vue.extend({
	components: {Spinner},
	props: {
		formats: Array as () => NormalizedFormat[],
		loading: Boolean
	},
})
